import * as React from 'react';
import { Col, Grid } from 'lib/grid';
import { Icon, PageHeader } from '@salesforce/design-system-react';
import { Chart } from './AnalyticsChart';
import { AnalyticsBarData, ScreenName, AnalyticsChartConfigs } from 'lib/types';
import CountUp from 'react-countup';
import { withBrandData } from 'lib/withBrand';

const add = (sum: number, value: number) => sum + value;
const sumWith = (cmp: AnalyticsCard, getProp: (b: AnalyticsBarData) => number) => 
	cmp.chartData().map(getProp).reduce(add, 0);

interface AnalyticsCardProps {
	brandData: AnalyticsChartConfigs;
	screen: ScreenName;
}

class AnalyticsCard extends React.Component<AnalyticsCardProps> {
	static defaultProps = {
		brandData: {
			chart: {
				axesLabelSuffix: '',
				axesColor: '',
				barHeight: 0,
				barPadding: 0,
				barValueY: 0,
				barValueX: 0,
				height: '',
				labelWidth: 0,
				logScale: false,
				topPadding: 0,
				width: '',
				uniquesAnimateDelay: 0,
				units: ''
			},
			data: []
		}
	};

	svg: HTMLElement;
	totalCount: number;
	uniqueCount: number;

	constructor (props: AnalyticsCardProps) {
		super(props);
	}

	componentDidMount () {
		if (!this.isEmpty()) {
			this.renderChart();
		}
	}

	componentDidUpdate (prevProps: AnalyticsCardProps) {
		if (prevProps.brandData !== this.props.brandData) {
			if (!this.isEmpty()) {
				this.renderChart();
			}
		}
	}
	
	setupComplete () {
		return ['dashboard2', 'dashboard3'].includes(this.props.screen);
	}

	animateUniques () {
		return this.props.brandData.animateUniques;
	}

	isEmpty () {
		return this.props.brandData.isEmpty;
	}

	animateTotals () {
		return this.props.brandData.animateTotals;
	}

	chartConfig () {
		return this.props.brandData;
	}

	chartData () {
		return this.props.brandData.data;
	}

	totalInputInts () {
		return this.totalCount.toFixed(1).split('.');
	}

	uniqueInputsInts () {
		return this.uniqueCount.toFixed(1).split('.');
	}

	renderChart () {
		Array.from(this.svg.children).forEach((child) => child.remove());
		const chart = new Chart(this.svg, this.chartConfig());
		chart.render();
	}

	render () {
		const uniquesLabel = this.props.brandData.uniquesLabel || 'Unique Consumer Records';
		const totalsLabel = this.props.brandData.totalsLabel || 'Input Consumer Records';
		const units = this.props.brandData.chart.units;
		const barCount = this.props.brandData.data.length;
		this.totalCount = sumWith(this, bar => parseFloat(bar.totalCount));
		this.uniqueCount = sumWith(this, bar => parseFloat(bar.uniqueCount));
		// const hasUniques = this.uniqueCount < this.totalCount;
		const hasUniques = true;
		const [totalTen, totalOne] = this.totalInputInts();
		const [uniqueTen, uniqueOne] = this.uniqueInputsInts();

		return (
			<Col className="dashboard_analytics">
				<PageHeader
					contentRight={<div style={{height: '30px'}}/>}
					icon={
						<Icon
							category="standard"
							name="report"
							style={{backgroundColor: '#1A57A2'}}
						/>
					}
					label="Customer 360 Data Manager"
					title="Analytics"
					variant="objectHome"
				/>
				<Grid className="dashboard_analytics-totals">
					<Col size="1-of-2">
						<p className="slds-text-body_regular">{totalsLabel}</p>
						{/*<p className="slds-text-heading_large">{totalTen}.{totalOne}{units}</p>*/}
						<p className="slds-text-heading_large">
							{this.animateTotals() ?
								<span>
									<CountUp start={0} end={totalTen} duration={1.5} useEasing={false} />
									.
									<CountUp start={0} end={totalOne} duration={1.5} useEasing={false} />{units}
								</span> :
								// hasUniques ? `${totalTen}.${totalOne}${units}` : <span className="slds-text-color_weak">N/A</span>
								`${totalTen}${this.isEmpty() ? '' : '.' + totalOne +  units}`
							}
						</p>
					</Col>
					<Col size="1-of-2">
						<p className="slds-text-body_regular">{uniquesLabel}</p>
						<p className="slds-text-heading_large">
							{hasUniques && this.animateUniques() ?
								<span>
									<CountUp start={0} end={uniqueTen} duration={2} useEasing={false} />
									.
									<CountUp start={0} end={uniqueOne} duration={2} useEasing={false} />{units}
								</span> :
								// hasUniques ? `${uniqueTen}.${uniqueOne}${units}` : <span className="slds-text-color_weak">${uniqueTen}</span>
								`${uniqueTen}${this.isEmpty() ? '' : '.' + uniqueOne +  units}` 

							}
						</p>
					</Col>
				</Grid>
				{this.isEmpty() ? 
					<img id="emptyImage" src="/assets/images/empty.png" />
					: 
					<div>
						<div ref={(svg) => this.svg = svg as HTMLElement} style={{height: `${120 + (barCount * 31)}px`}} />
						<a href="javascript:void(0)" className="view-more">View More</a>
					</div>
				}
			</Col>
		);
	}
}

export default withBrandData('chart', AnalyticsCard);


// WEBPACK FOOTER //
// ./src/Dashboard/AnalyticsCard.tsx